module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hamv-dialog', {
    attrs: {
      "dialogProps": _vm.dialogProps,
      "showModal": _vm.showModal
    }
  }, [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "header",
      "data-qa": "Dialog-DeleteFirmware-Title"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('firmwareDeleteDialogTitle')))]), _vm._v(" "), _c('i18n', {
    attrs: {
      "path": "firmwareDeleteDialogConfirmText",
      "data-qa": "Dialog-DeleteFirmware-ConfirmText",
      "tag": "span"
    }
  }, [_c('el-tag', {
    attrs: {
      "place": "version",
      "type": "info"
    }
  }, [_vm._v(_vm._s(_vm.version))])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, _vm._l((_vm.buttons), function(button, index) {
    return _c('el-button', {
      key: index,
      class: button.class,
      attrs: {
        "data-qa": ("Dialog-DeleteFirmware-Button-" + (button.id)),
        "type": button.type || 'warning'
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return button.click($event)
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.$t(button.text)) + "\n    ")])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99e9af6c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FirmwareDelete/FirmwareDelete.vue
// module id = 979
// module chunks = 3